import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=c1370dd6&scoped=true"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"
import style0 from "./TrashIcon.vue?vue&type=style&index=0&id=c1370dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1370dd6",
  null
  
)

export default component.exports